"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/People/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _peers = require('shared/selectors/peers');
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _useOrgAccount = require('shared/hooks/useOrgAccount');
var _common = require('shared/selectors/org/common');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _Avatar = require('web/components/Avatar');
var _DataTable = require('web/components/DataTable'); var _DataTable2 = _interopRequireDefault(_DataTable);

var _format = require('web/screens/Directory/PatientTable/format');
var _hooks = require('web/services/hooks');
var _ChangeRoleModal = require('./ChangeRoleModal'); var _ChangeRoleModal2 = _interopRequireDefault(_ChangeRoleModal);
var _OrgPills = require('./OrgPills'); var _OrgPills2 = _interopRequireDefault(_OrgPills);
var _PersonCard = require('./PersonCard'); var _PersonCard2 = _interopRequireDefault(_PersonCard);
var _RemoveFromAccountModal = require('./RemoveFromAccountModal'); var _RemoveFromAccountModal2 = _interopRequireDefault(_RemoveFromAccountModal);
var _Tooltip = require('web/components/Tooltip');
var _people = require('./people');








const INITIAL_SORT = { sort: 'name' , desc: false }
const INITIAL_FILTERS = {}
const rowKey = (p) => p.UserKey

/* Account → People (A8, J12): everyone on the account once, with their
 * organizations, role and who manages their memberships; searched, filtered,
 * sorted and paged on the server. A row opens the person card. Nobody is
 * added or removed here (D-68). */
const People = ({ orgKey, account, personKey }) => {
  const orgs = _hooks.useAppSelector.call(void 0, _common.selectOrgs)
  const orgName = _react.useCallback.call(void 0, (k) => _nullishCoalesce(_optionalChain([orgs, 'access', _ => _[k], 'optionalAccess', _2 => _2.Name]), () => ( 'Organization')), [orgs])

  const fetch = _react.useCallback.call(void 0, 
    (r) => _actions2.default.listAccountPeople({
      OrgKey: orgKey,
      Query: r.query || undefined,
      FilterOrgKey: r.filters.org,
      FilterManagedBy: r.filters.managedBy,
      Sort: r.sort,
      Desc: r.desc,
      Offset: r.offset,
      Limit: r.limit,
    }).then(res => ({ rows: res.People, total: res.Total })),
    [orgKey],
  )
  const table = _DataTable.useDataTable.call(void 0, { fetch, initialSort: INITIAL_SORT, initialFilters: INITIAL_FILTERS })
  _useBus2.default.call(void 0, _useOrgAccount.PEOPLE_CHANGES, table.reload)

  const [openKey, setOpenKey] = _react.useState(null)
  const [changingRole, setChangingRole] = _react.useState.call(void 0, false)
  // Who the Remove from account dialog is for (D-125).
  const [removing, setRemoving] = _react.useState(null)
  // The open person as last seen, kept while a reload or new page leaves them out.
  const [lastOpen, setLastOpen] = _react.useState(null)
  const openPerson = _nullishCoalesce(table.rows.find(p => p.UserKey === openKey), () => ( (_optionalChain([lastOpen, 'optionalAccess', _3 => _3.UserKey]) === openKey ? lastOpen : null)))
  const onOpen = _react.useCallback.call(void 0, (p) => {
    setOpenKey(p.UserKey)
    setLastOpen(p)
  }, [])
  const onClose = _react.useCallback.call(void 0, () => setOpenKey(null), [])
  const canChangeRoles = _useOrgAccount.grantableAccountRoles.call(void 0, account.MyRole).length > 0

  // A linked person: search for them, so their row shows highlighted, and
  // open their card when it arrives. Once per link.
  const linkedEmail = _hooks.useAppSelector.call(void 0, state => personKey ? _optionalChain([_peers.selectUserByKey.call(void 0, state, personKey), 'optionalAccess', _4 => _4.Email]) : undefined)
  const [handledLink, setHandledLink] = _react.useState(null)
  const { setSearch } = table
  _react.useEffect.call(void 0, 
    () => {
      if (personKey && linkedEmail && handledLink !== personKey) setSearch(linkedEmail)
    },
    [personKey, linkedEmail, handledLink, setSearch],
  )
  _react.useEffect.call(void 0, 
    () => {
      if (!personKey || handledLink === personKey) return
      const linked = table.rows.find(p => p.UserKey === personKey)
      if (linked) {
        onOpen(linked)
        setHandledLink(personKey)
      }
    },
    [personKey, handledLink, table.rows, onOpen],
  )

  const columns = _react.useMemo.call(void 0, () => [
    {
      id: 'name',
      label: 'Name',
      sort: 'name',
      width: 240,
      // The staff avatar the person card and member lists use: their photo,
      // or the default staff icon.
      cell: p => (
        _react2.default.createElement('div', { className: "account-people--person", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
          , _react2.default.createElement(_Avatar.UserAvatar, { userKey: p.UserKey, size: 32, noOnlineIndicator: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}} )
          , _react2.default.createElement('div', { className: "account-people--who", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
            , _react2.default.createElement('span', { className: "account-people--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}},  _people.personName.call(void 0, p) )
            , _react2.default.createElement('span', { className: "account-people--email", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}},  p.Email )
          )
        )
      ),
    },
    {
      id: 'orgs',
      label: 'Organizations',
      width: 220,
      cell: p => _react2.default.createElement(_OrgPills2.default, { names: _OrgPills.orderOrgNames.call(void 0, p.Memberships.map(m => m.OrgKey), orgName, account.DefaultOrgKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}} ),
    },
    { id: 'role', label: 'Role', sort: 'role', width: 120, cell: p => _people.roleLabel.call(void 0, p, orgName) },
    {
      id: 'managedBy',
      label: 'Managed by',
      width: 150,
      cell: p => (
        _react2.default.createElement('div', { className: "account-people--pills", __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
          ,  _people.managedLabels.call(void 0, p).map(l => _react2.default.createElement('span', { key: l, className: "account-people--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}},  l )) 
        )
      ),
    },
    { id: 'lastActive', label: 'Last active', width: 150, cell: p => _format.formatActivity.call(void 0, _nullishCoalesce(p.LastActive, () => ( undefined))) },
    {
      id: 'actions',
      label: '',
      cell: p => {
        const why = _useOrgAccount.removeFromAccountBlocker.call(void 0, p, orgName)
        const stop = (e) => e.stopPropagation()
        const button = (
          _react2.default.createElement('button', {
            type: "button",
            className: "account-people--remove",
            'aria-label': `Remove ${_people.personName.call(void 0, p)} from the account`,
            'aria-disabled': why ? true : undefined,
            onClick: e => { stop(e); if (!why) setRemoving(p) },
            onKeyDown: stop, __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
, "Remove"

          )
        )
        return why
          ? _react2.default.createElement(_Tooltip.HoverTooltip, { type: "dark", place: "left", showOnFocus: true, className: "account-people--remove-wrap", content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 151}},  why ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}},  button )
          : button
      },
    },
  ], [orgName, account.DefaultOrgKey])

  const { filters, setFilters } = table
  const filterPanel = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_DataTable.DataTableFilterGroup, {
        label: "Organization",
        options: account.OrgKeys.map(k => ({ value: k, label: orgName(k) })),
        value: filters.org,
        onChange: org => setFilters({ ...filters, org }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}
      )
      , _react2.default.createElement(_DataTable.DataTableFilterGroup, {
        label: "Managed by" ,
        options: _people.MANAGED_BY_OPTIONS,
        value: filters.managedBy,
        onChange: managedBy => setFilters({ ...filters, managedBy }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}
      )
    )
  )

  return (
    _react2.default.createElement('div', { className: "account-people", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
      , _react2.default.createElement('p', { className: "account-people--lead", __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}, "Everyone across all organizations: which organizations they're in, their role, and who manages their membership."

      )
      , _react2.default.createElement(_DataTable2.default, {
        label: "People",
        table: table,
        columns: columns,
        rowKey: rowKey,
        rowLabel: _people.personName,
        searchPlaceholder: "Search by name or email"    ,
        filters: filterPanel,
        activeFilters: [filters.org, filters.managedBy].filter(Boolean).length,
        noun: ['person', 'people'],
        onOpen: onOpen,
        openKey: openPerson ? openKey : null,
        emptyState: table.query || filters.org || filters.managedBy ? 'No one matches.' : 'No one yet.', __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
      )
      ,  openPerson && (
        _react2.default.createElement(_PersonCard2.default, {
          person: openPerson,
          orgName: orgName,
          onChangeRole: canChangeRoles ? () => setChangingRole(true) : undefined,
          onRemove: () => setRemoving(openPerson),
          removeBlocker: _useOrgAccount.removeFromAccountBlocker.call(void 0, openPerson, orgName),
          onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}
        )
      )
      ,  removing && (
        _react2.default.createElement(_RemoveFromAccountModal2.default, {
          orgKey: orgKey,
          person: removing,
          orgName: orgName,
          onClose: () => setRemoving(null),
          onRemoved: () => {
            if (openKey === removing.UserKey) setOpenKey(null)
            setRemoving(null)
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}
        )
      )
      ,  openPerson && changingRole && (
        _react2.default.createElement(_ChangeRoleModal2.default, {
          orgKey: orgKey,
          person: openPerson,
          myRole: account.MyRole,
          onClose: () => setChangingRole(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}
        )
      )
    )
  )
}

exports. default = People
